// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GeRpV","col":"styles_col__2o9hJ"};